import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { NewButton, Icon, H2 } from '../../../../../components';

const ShareModalHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const ShareModalHeader = ({ title, onClose, className = null }) => (
  <ShareModalHeaderWrapper className={className}>
    <H2>{title}</H2>
    <NewButton onClick={onClose} tertiary>
      <Icon name='close' displaySize={24} color='var(--black)' />
    </NewButton>
  </ShareModalHeaderWrapper>
);

ShareModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string
};

export { ShareModalHeader };
